<template>
  <template v-if="isLoaded">
    <div class="farm-window text-window help-card">
      <div>
        <h2>Help</h2>
      </div>
      <template v-if="showExitButton">
        <TextButton class="farm-button" @click="$emit('close')">
          <h3>X</h3>
        </TextButton>
      </template>
      <div class="farm-list help-list">
        <div class="farm-window">
          <h3>Employees</h3>
          <div>
            <p><b>Salary</b></p>
            <p>Affects the employee's mood. The more intelligent an employee is, the more pay they will want.</p>
          </div>
          <div><p>
            <b>Intelligence</b></p>
            <p>Affects how much science an employee assigned to the Lab will generate, and how well an employee assigned to the Office will do.</p>
          </div>
          <div>
            <p><b>Happiness</b></p>
            <p> Happier employees do better at almost any task. Try to keep your staff happy! </p>
          </div>
          <div>
            <p><b>Lust</b></p>
            <p> How horny your employee is. <b>Hornier employees are less intelligent, but also produce milk faster</b>. If an employee becomes too horny and has to masturbate, they will be a little less happy for a while. </p>
          </div>
          <div>
            <p><b>Milk</b></p>
            <p> Shows current employee milk levels and how fast they are producing. Hold the 'Milk' button to milk them.</p>
          </div>
        </div>

        <div class="farm-window">
          <h3>Personalities</h3>
          <p>Each employee has two words describing their personality. Their personality changes their stats and how some actions affect them.</p>
          <div v-for="personality in this.allPersonalities()">
            <p><b>{{ personality.name }}</b></p>
            <p>{{ personality.description() }}</p>
          </div>
        </div>

        <div class="farm-window">
          <h3>Tabs and Rooms</h3>
          Each room gives you access some features of the farm, but staff can also be assigned to each room to give particular bonuses.
          <div>
            <p><b>Menu</b></p>
            <p>Pauses the game while you're on it. Allows you to manage saves.</p>
          </div>
          <div><p>
            <b>Office</b></p>
            <p> Hire staff and assign them to tasks. See milk market and adjust your selling price. Also lists recent news. Staff assigned here can be given further tasks to help you out.</p>
          </div>
          <div>
            <p><b>Pasture</b></p>
            <p> Take care of your employees needs and see their stats. Staff assigned here have increased milk production stats.</p>
          </div>
          <div>
            <p><b>Lab</b></p>
            <p> Allows you to research new upgrades and items for the farm and your employees. Staff assigned here generate science.</p>
          </div>
        </div>

        <div class="farm-window">
          <h3>Market</h3>
          The milk market can be accessed from the Office. It determines how much milk you can sell to what price.
          <div>
            <p><b>Storage</b></p>
            <p>How much milk you have stored. Fill by milking staff. Max can be increased by research.</p>
          </div>
          <div><p>
            <b>Milk Price</b></p>
            <p>How much you are selling milk for. You can adjust this as you want. Max price is determined by demand and market level. Selling for a lower price means you can satisfy more of the demand.</p>
          </div>
          <div>
            <p><b>Demand</b></p>
            <p>How much milk you can sell. Demand can be generated faster by assigning office staff to advertising, and through research. It also generates faster when the current demand is lower. Max demand is determined by market level. When demand reaches max demand, market level will increase by 1.</p>
          </div>
          <div>
            <p><b>Market Level</b></p>
            <p>A measure of how big the market is and how much competition there is. A higher market level means more total demand, a higher maximum milk price, but also lower demand generation (since your competitors are satisfying some of it!). Market level increases by 1 whenever the current demand maximum is reached.</p>
          </div>
        </div>

        <div class="farm-window">
          <h3>Tips and Tricks</h3>
          <div>
            <p><b>Assign</b></p>
            <p>Plan how you want to assign your employees based on their starting stats and personality. That will keep them happy in the long run.</p>
          </div>
          <div>
            <p><b>Lust</b></p>
            <p>Managing your employees lust can be an important step to success!</p>
          </div>
          <div>
            <p><b>Economics</b></p>
            <p>If you run out of money, your staff will all become sad and not do any work until you're back in the positive. So keep you money above $0!</p>
          </div>
          <div>
            <p><b>Interact</b></p>
            <p>Use the various buttons to interact with your employees. Their stats affect how well they do certain tasks!</p>
          </div>
          <div>
            <p><b>Events</b></p>
            <p>Watch out for various events that can alter your employees for some time!</p>
          </div>
        </div>

      </div>
    </div>
  </template>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import util from '../util'
import TextButton from '@/components/ui/TextButton.vue'
import SavesCard from '@/components/SavesCard.vue'
import SaveSystem from '@/SaveSystem'
import PatreonButton from '@/components/ui/PatreonButton.vue'
import { Personality } from "@/employee/Personality"
import { allPersonalities } from "@/employee/Personalities"

@Options({
  components: {
    SavesCard, TextButton, PatreonButton
  },
  props: {
    showExitButton: {
      type: Boolean,
      default: true
    }
  },
  emits: ['close'],
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    util() {
      return util
    },
    window() {
      return window
    },
    allPersonalities(): Personality[] {
      return Object.entries(allPersonalities()).map(value => value[1])
    }
  },
  async created() {
    //let farm = new Farm()
    //await farm.load()
    //this.farm = farm
    this.isLoaded = true
  }
})
export default class HelpCard extends Vue {
  isLoaded = false
  showExitButton!: boolean
}
</script>

<style scoped lang="scss">

.text-window {
  box-sizing: border-box;
  flex-direction: column;
  min-height: 500px;
  max-width: 700px;
  max-height: 100%;
  margin: 0 auto;
  padding: 10px;

  display: grid;
  grid-template-rows: 30px auto;
  grid-template-columns: auto 50px;
  grid-template-areas:
    "t x"
    "c c";
  grid-gap: 10px;

  h2 {
    margin: 0;
    line-height: 100%;
  }

  p {
    margin-top: 1em;
    margin-bottom: 1em;
  }

  @media screen and (max-width: $mobile-width){
    padding: 10px;
    margin: 0 auto;
  }
}

.patreon-button {
  grid-area: p;

  box-sizing: border-box;
  margin: auto;
  width: 100%;
  max-width: 600px;
  max-height: 150px;
}

.stat-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: minmax(40px, 1fr);
}

.text-button {
  border: $component-border-style;

  display: table;
  div {
    display: table-cell;
    vertical-align: middle;
  }

  & > h3 {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }
}

.help-list {
  grid-area: c;

  overflow-y: auto;

  .farm-window {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    div {
      display: grid;
      grid-template-columns: 11ch 1fr;
      padding-top: 5px;
      padding-bottom: 5px;
      //border-top: 1px solid white;
      margin-top: 5px;
      background: rgba($component-background-color, 0.5);
      border-left: 3px solid white;
      padding-left: 10px;

      p:nth-child(2) {
        border-left: 1px solid white;
        padding-left: 10px;
        color: #eee;

        b {
          color: white;
        }
      }
    }
  }

  p {
    margin: 0;
  }
}

.credits-block {
  &:first-child {
    h3 {
      margin-top: 0;
    }
  }

  h3 {
    margin-bottom: 5px;
    margin-top: 15px;
  }

  p {
    margin: 0;
  }
}
</style>
